import checkMovieByTimeRangeAndCinemas from "./checkMovieByTimeRangeAndCinemas"

const filterMoviesByTimeRangeAndCinema = (order, items, performances, startDate, endDate, cinemaIds = false) => {
    const data = {
        relevant: [],
        current: [],
        future: [],
    }

    order.map(itemId => {
        const movie = items[itemId]
        const { inCinema, isCurrent, isFuture } = checkMovieByTimeRangeAndCinemas(movie, performances, startDate, endDate, cinemaIds)

        if((cinemaIds && inCinema) || !cinemaIds) {
            data.relevant.push(itemId)

            if(isCurrent) {
                data.current.push(itemId)
            } else if(isFuture) {
                data.future.push(itemId)
            }
        }
    })
    
    return data
}

export default filterMoviesByTimeRangeAndCinema